<template>
  <div :class="['content-text', sizeComp, textAlignComp, weightComp, fontStyleComp]" :style="colorComp">
    <nt-tag :tag="tag"> 
      <slot></slot>
    </nt-tag>
  </div>
</template>

<script>

export default {
  name: 'content-text',
  props: {
    size: {
      type: String,
      default: 'medium'
    },
    horizontalAlign: {
      type: String,
      default: 'center'
    },
    textAlign: {
      type: String,
      default: 'left'
    },
    color: {
      type: String,
      default: '#FFF'
    },
    weight: {
      type: String,
      default: 'normal'
    },
    fontStyle: {
      type: String,
      default: 'normal'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    colorComp() {
      return `color: ${this.color}`
    },
    sizeComp() {
      return `content-text--${this.size}`
    },
    textAlignComp() {
      return `content-text--text-align-${this.textAlign}`
    },
    weightComp() {
      return `content-text--weight-${this.weight}`
    },
    fontStyleComp() {
      return `content-text--style-${this.fontStyle}`
    },
  }
}
</script>

<style lang="scss" scoped>
$base-font-xs: 1.000em; // 16
$base-font-sm: 1.125em; // 20
$base-font-df: 1.250em; // 22
$base-font-md: 1.375em; // 24
$base-font-lg: 1.500em; // 26
$base-font-xl: 1.625em; // 28
$base-font-xxl: 1.750em; // 30

.content-text {
  color: #FFF;
  // display: flex;
  // flex-wrap: wrap;
  // flex: initial;
  line-height: 1.2em;
  letter-spacing: -0.5px;
  // font-weight: 700;

  &--extrasmall {
    font-size: $base-font-xs;
  }

  &--small {
    font-size: $base-font-sm
  }

  &--default {
    font-size: $base-font-df
  }

  &--medium {
    font-size: $base-font-md
  }

  &--large {
    font-size: $base-font-lg
  }

  &--extralarge {
    font-size: $base-font-xl
  }

  &--xxlarge {
    font-size: $base-font-xxl
  }

  // &--center {
  //   justify-content: center;
  // }

  // &--start {
  //   justify-content: flex-start;
  // }

  // &--end {
  //   justify-content: flex-end;
  // }

  &--text-align-center {
    text-align: center;
  }

  &--text-align-start {
    text-align: left;
  }

  &--text-align-end {
    text-align: right;
  }

  &--text-align-justify {
    text-align: justify;
  }

  &--weight-lighter {
    & > * {
      font-weight: lighter;
    }
  }

  &--weight-normal {
    & > * {
      font-weight: normal;
    }
  }

  &--weight-bold {
    & > * {
      font-weight: bold;
    }
  }

  &--style-italic {
    font-style: italic;
  }
}
</style>